/* global StripeCheckout:true */

const Stripe = function (stripeOpts) {
    const {
        formEl,
        modal,
        formData
    } = stripeOpts;

    const stripeScriptTag = document.createElement('script');

    stripeScriptTag.onload = () => {
        const stripeHandle = StripeCheckout.configure({
            key: formEl.dataset.stripeApiKey,
            image: `${location.origin}/static/dist/bell.png`,
            locale: 'auto',
            token: function (token) {
                formEl.querySelector('input[name="payment_token"]').value = token.id;
                formEl.submit();
                stripeHandle.close();
                document.body.removeChild(stripeScriptTag);
            }
        });

        stripeHandle.open({
            name: 'Dial-A-Song Direct',
            description: 'They Might Be Giants',
            zipCode: true,
            amount: 3000,
            email: formData.get('email'),
            opened () {
                modal.hide();
            }
        });
    };
    stripeScriptTag.src = 'https://checkout.stripe.com/checkout.js';
    document.body.appendChild(stripeScriptTag);
};

export default Stripe;



// WEBPACK FOOTER //
// ./assets/js/components/Stripe.js